<script>
	import ContentLink from '$lib/Components/Layout/ContentLink/ContentLink.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import { caseStudies } from './casestudies-data';

	// case studies may have duplicate groups, so we need to merge them
	// TODO: implement something like a tag system rather than nested "group"s
	const groupMap = caseStudies.reduce((acc, group) => {
		if (!acc[group.group]) {
			acc[group.group] = group;
		} else {
			acc[group.group].items.push(...group.items);
		}
		return acc;
	}, {});
	const mergedCaseStudies = Object.values(groupMap);
</script>

<Section backgroundColor="white">
	<p>
		We've helped thousands of people improve the comfort, quiet, and efficiency
		of their homes and businesses - but don't take our word for it! Hear
		directly from customers just like you who were able to tackle frustrating
		window deficiencies with the help of Indow inserts.
	</p>

	{#each mergedCaseStudies as group (group.group)}
		<h2 class="mb-1 text-left text-base">{group.title}</h2>
		<hr />
		<ul
			class="
     mb-8 grid list-none grid-cols-1 gap-x-4 gap-y-6
     md:grid-cols-2
   "
		>
			{#each group.items as { title, subtitle, href, image } (href)}
				<li>
					<ContentLink {title} {subtitle} {href} {image} />
				</li>
			{/each}
		</ul>
	{/each}
</Section>

<GetAFreeEstimate backgroundColor="blue" />
<FeaturedArticles />
